import { useEffect, useState } from 'react';
import { useStrictInstance } from '@funtech-int/rival-react';
import { paymentsRef } from '@funtech-int/yango-shared';

export const useIsPaymentManagerOpened = () => {
    const { modal } = useStrictInstance(paymentsRef);
    const [isOpened, setIsOpened] = useState(() => Boolean(modal.scenario.get()));

    useEffect(
        () =>
            modal.scenario.listen(() => {
                setIsOpened(Boolean(modal.scenario.get()));
            }),
        [modal.scenario]
    );

    return isOpened;
};
